import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IconButtonComponent } from "@components/icon-button/icon-button.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { SelectorComponent } from "@components/selector/selector.component";
import _ from "lodash";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { AnmalanTradslag, TradslagDTO, VKAtgardMbf } from "~app/features/virkeskop/models/mbf-models";
import { AtgardMbfService } from "~app/features/virkeskop/services/atgard-mbf.service";

@Component({
    selector: "rask-foryngring-tradslag",
    templateUrl: "./foryngring-tradslag.component.html",
    styleUrls: ["./foryngring-tradslag.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectorComponent,
        FormsModule,
        InputNumberComponent,
        IconButtonComponent
    ]
})
export class ForyngringTradslagComponent implements OnChanges {
    @Input() allatradslag: TradslagDTO[];
    @Input() anmalanTradslag: AnmalanTradslag;
    @Input() atgardMbf: VKAtgardMbf;
    @Output() deleted = new EventEmitter<AnmalanTradslag>();
    @Input() index: number;
    @Input() readonly = false;

    protected valttradslag: TradslagDTO;

    private readonly atgardMbfService = inject(AtgardMbfService);

    private throttle: any;

    antalPlantorChanged($event) {
        this.anmalanTradslag.antalPlantor = _.round(this.anmalanTradslag.antalPlantor, 0);
        this.somethingChanged();
    }

    arealHaChanged($event) {
        this.somethingChanged();
    }

    delete(): void {
        if (this.readonly) {
            return;
        }
        this.deleted.emit(this.anmalanTradslag);
    }

    excludedTradslag() {
        const currentId = this.anmalanTradslag?.tradslagId;
        const others = this.atgardMbf?.anmalanTradslag?.filter(x => x.tradslagId && x.tradslagId !== currentId).map(ts => ts.tradslagId);
        return this.allatradslag?.filter(ts => others.some(o => o === ts.id));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.allatradslag && this.anmalanTradslag) {
            this.valttradslag = this.allatradslag.find(t => t.id === this.anmalanTradslag.tradslagId);
        }
    }

    tradslagChanged($event) {
        if (ObjectUtils.hasValue($event) && $event?.id !== this.anmalanTradslag?.tradslagId) {
            this.anmalanTradslag.tradslagId = $event.id;
            this.update();
        }
    }

    viewFormatter = (td: TradslagDTO): string => td != null ? td.externkod : "";

    private somethingChanged(): void {
        clearTimeout(this.throttle);
        this.throttle = setTimeout(() => {
            this.update();
        }, 50);
    }

    private update(): void {
        this.atgardMbfService.updateAnmalanTradslag(
            this.anmalanTradslag.guid,
            this.anmalanTradslag.tradslagId,
            this.anmalanTradslag.arealHa,
            this.anmalanTradslag.antalPlantor);
    }
}
